export default {
  title: { //各页面标题 路由 index 内
    home: 'home',
    sec_kill: 'sec_kill',
    product_list: 'product_list',
    search: 'search',
    search_item: 'search_item',
    product_detail: 'product_detail',
    share_with_money: '分享领现金',
    share_page: '分享领现金',
    share_get_page: '分享领现金',
    ssh: 'ssh',
    download_page: 'download_page',
    share_img: 'share_img',
    fang_jia_tong_zhi: 'fang_jia_tong_zhi',
  },
  // 页面文案
  home: {},
  order: {
    help: {
      title: '需要帮助吗？',
      text: '您可以通过以下方式联繫我们：',
      link: {
        title: '客服热线',
        tel_1: '(852) 2508-0998',
        tel_2: '(86) 0755-2590-1884',
        rank: '(週一至週日：9 : 30AM - 8 : 00PM',
      },
      email: {
        title: '官方邮箱',
        text: 'info@jewellery-box.com'
      },
      promise: {
        title: '搜饰盒购物承诺',
        title_1: '包邮政策',
        text_1: '购物消费满$1500即可享受包邮服务',
        title_2: '7天无理由退换',
        text_2: '搜饰盒承诺所有商品享受七天无理由 退换货',

      }
    },
    confirm: {
      title: '确认订单',
      md_text: '门店自提',
      zr_text: '寄送上门',
      receive_info: {
        title: '取货人信息',
      },
      address: {
        title: '送货地址',
        add: '新增地址'
      },
      order_detail: {
        title: '订单明细',
        sum: '小计',
        ship: '配送',
        total: '总价',
      },
      button: {
        back: '继续购物',
        submit: '提交订单',
      }
    }
  },
  form: {
    name: '姓名',
    first_name: '姓氏',
    last_name: '名字',
    email: '邮箱',
    area_code: '区号',
    phone: '电话',
    validator: {
      name: '请填写姓名',
      first_name: '请填写姓氏',
      last_name: '请填写名字',
      email: '请填写邮箱地址',
      area_code: '请选择区号',
      phone: '请填写电话',
      address: '请选择地区并填写详细地址',
    },
    placeholders: {
      email: '*邮箱地址',
      phone: '*电话号码',
      address: '请填写详细地址',
    }
  },
  // 其他
  exchange_support: '支持无限换戴',
  share_img_button: '长按图片保存至手机',
  token_required: '请先登陆',
  token_expire: '登陆或已过期，请重新登陆',
  price_sign: '￥',
  price_text: '售价',
  empty: '没有更多了',
  loosing: '释放即可刷新...',
  loading: '加载中...',
  reload: {
    success: '刷新成功',
    failed: '刷新失败',
  },

  mall_home: {
    location: 'HongKong',
    my_account: 'My Account',
    account_num: 'Account',
    logout: 'Logout',
    please: 'Please',
    login: 'Login',
    register: 'Register',
    infor: 'Personal Information',
    my_order: 'My Order',
    my_wishlist: 'My Wishlist',
    jewellery_box: 'Jewellery-Box',
    fine_jewellery: 'Fine Jewellery',
    brand: 'About The Brand',
    about_us: 'Our Brand',
    about_exchange: 'Jewellery Hassle-Free Exchange',
    about_vip: 'Superior Experience',
    about_boss: 'Strong Shareholder Capabilities',
    about_honor: 'Awards and Qualification',
    about_history: 'Milestone',
    about_join_us: 'Recruit City Partners',
    download: 'App Download',
    hot: 'Hot KOL',
    gia: 'Diamond Custom',
    jewellery_type: 'Shop by category',
    jewellery_collect: 'Shop by collection',
    brand_type: 'category',
    new_collection: 'New Collection',
    exchange: 'Jewellery Hassle-free Exchange',
    find_store: 'Find a store',
    explore_products: 'Explore Products',
    total: 'Total',
    view_cart: 'View Cart',
    chose: 'chose',
    items: 'items',
    shop: 'Shop',
    all: 'All',
    all_product: 'Comprehensive',
    rg: 'Ring',
    bg: 'Bracelet',
    er: 'Earring',
    bl: 'Chain',
    pd: 'Pendant',
    nl: 'Necklace',
    cl: 'Men\'s',
    w_ring: 'Wedding Ring',
    mens: 'Men\'s',
    search_series_type:'Search Series/Type/Style Number',
    company:'© Copyright, Inheritance Technology Co. Ltd. All Rights Reserved.'
  },
  mall_detail: {
    color: 'Color',
    size: 'Size',
    params: 'Parameters',
    add_cart: 'Add to Cart',
    to_buy: 'Checkout',
    you_like: 'You May Also Like',
    my_cart: 'My Shopping Cart',
    have: 'have',
    items: 'items',
    total: 'Total',
    checkout: 'Checkout',
    free_size: 'Free Size',
    free_num: '',
    choose_size: 'Select Size',
    success_add:'Successfully adding',
    select_color:'Please select a color',
    select_size:'Please select size',
    cart_empty:'Your cart is empty'
  },
  mall_search: {
    sort_by: 'Sort by',
    low_2_high: 'Low to High Price',
    high_2_low: 'High to Low Price',
    new: 'New Collection',
    buy: 'Shop',
    loading: 'Loading ...',
    no_more: 'No More ...',
    collected:'Already collected',
    collection_cancel:'Collection cancelled'
  },
  mall_login: {
    phone_login: 'Phone Login',
    area_num: 'Area',
    input_phone: 'Please enter phone number',
    input_code: 'Verification code',
    phone_pwd: 'Mobile verification code',
    input_phone_pwd: 'Please enter 6 digit password',
    code_resend: 'Didn\'t get the captcha? To resend',
    success: 'Success',
    message_has_sent: 'The message has been sent',
    error: 'Error',
    error_phone: 'The phone number is wrong, please fill in again',
    error_phone_pwd: 'Please fill in the correct code',
    success_login: 'Login successful',

  },
  mall_self_page: {

    appellation: 'Appellation',
    man: 'Sir',
    woman: 'Lady',
    first_name: 'Family Name',
    input_first_name: 'Please enter your family name',
    last_name: 'Given Name',
    input_last_name: 'Please enter your given name',
    birthday: 'Birthday',
    select_date: 'Select a date',
    email: 'Email',
    input_email: 'Please enter your email address',
    cancel: 'Give up',
    save: 'Save',
    input_birth: 'Please fill in the date of birth',
    success_changed: 'Successfully changed'
  },
  mall_profile: {
    my_account: 'My Account',
    welcome: 'Welcome Back',
    user_infor: 'Personal Information',
    my_order: 'My Order',
    my_cart: 'My Wishlist',
  },
  mall_order: {
    all_order: 'All Orders',
    have: 'have',
    items_order: 'items',
    items_product:'items',
    no_more_tips:'NO ORDER FOUND',
    pay:'Pay',
    cancel:'Cancel',
    shop:'Go Shopping',
    including_postage:'Including postage',
    order_cancel:'The order has been successfully cancelled',
  },
  mall_cart:{
    total:'Total',
    pay:'Pay',
    no_more:'Your cart is empty',
    go_shop:'Go shopping',
    success_delete:'Deleted successfully',
    cart_none:'Your cart is empty',
  },
  mall_download: {
    bring_moment: 'Bring you a wonderful moment'
  },
  mall_bottom:{
    promise:{
      icon_1:'Professional Manufacturer Supply',
      icon_2:'87 Principles of Testing',
      icon_3:'100% Quality Guarantee',
      icon_4:'Pay Three For one Fake',
      icon_5:'Jewellery Hassle-Free Exchange',
      icon_6:'Jewellery Upgrade Exchange',
    },
    about_me:{
      title:'About Us',
      about_us: 'Our Brand',
      about_honor: 'Awards and Qualification',
      about_history: 'Milestone',
      about_join_us: 'Recruit City Partners',
    },
    guide:{
      title:'Shopping Guide',
      buy_way:'Purchasing Process',
      pay_way:'Payment Methods',
      store_way:'Store Address',
      about_exchange: 'Jewellery Exchange',
    },
    service:{
      title:'Help Center',
      rule_acceptance:'Acceptance and Indemnity',
      rule_exchange:'Exchange Policy',
      rule_user:'User Agreement',
      rule_privacy:'Privacy Policy Statement'
    },
    download:'App Download',
    contact_us:'Contact Us',
    follow_us:'Follow Us',
  },
  mall_order_detail:{
    order_detail:'view Order',
    order_num:'Order Number',
    receiver:'Receiver',
    phone_num:'Phone Number',
    address:'Delivery Address',
    total:'Total amount',
    pay:'Pay',
    cancel:'Cancel',
    service:'For refund/return, please contact customer service'
  },
  mall_pay_success:{
    pay_success:'Payment Successful！',
    tips:'Jewellery-box is preparing the accessories for you',
    view_order:'View Order'
  },
  mall_confirm_order:{
    md:'In-store pickup',
    md_tips:'（Free in charge）',
    zt:'Self pickup',
    zt_tips:'（Office, MTR station）',
    receiver:'Receiver',
    surname:'Surname',
    input_surname:'*Please fill in surname',
    given_name:'Given Name',
    input_name:'*Please fill in given name.',
    email:'Email',
    input_email:'*Please enter email address',
    phone:'Phone Number',
    input_phone:'*Please enter the phone number',
    zt_address:'*Please fill in the office/MTR station for settlement',
    ship_way:'Shipping address',
    add_address:'Add address',
    order_detail:'Your Order',
    subtotal:'subtotal',
    shipping:'shipping',
    user_coupon:'Apply coupon',
    input_code:'Enter the code',
    submit:'submit',
    remarks:'Remark(s)',
    input_remarks:'Please write down your special requirements',
    total:'Total Amount',
    support:'Support',
    continue_shopping:'Shopping',
    submit_order:'Submit',
    cheap:'Preferential ',
    address_tips:'Please complete/cancel the current address editing first',
    tips:'Tips',
    true_del:'Are you sure to delete?',
    create_order:'Order created successfully',
    input_md:'Please select a store',
    input_zr:'Please select a shipping address',
    input_zj:'Please fill in the place of delivery'
  },
  mall_order_index:{
    order_confirmation:'Confirm Order',
    pay_order:'Order Payment',
    pay_success: 'Payment Successful',
    need_help:'Need Help？',
    contact_us:'You may contact us through：',
    cs_hotline:'CS Hotline',
    work_day:'Working days:',
    mon_sun:'Mon to Sun  10:00AM - 6:00PM',
    office_email:'Official Email',
    shopping_promise:'Shopping Guarantee',
    policy:'Shipping Policy',
    policy_content:'When the product is ready, the customer service staff will contact you to make an appointment and deliver the product to offices and MTR stations all over Hong Kong (except outlying islands) for free',
    free_exchange: 'Free Exchange',
    exchange_content:'Anyone who buys diamond inset products in the search box can become a member of the search box and enjoy unlimited membership change service. Brand new jewelry, equivalent to wear',
    tips:'*The terms and conditions are subject to the application. For details, please check the search box App or contact our customer service staff。',
  },
  mall_pay_order:{
    payment_method:'Payment Method',
    credit_card:'Card Card',
    valid_term:'Valid Period',
    input_credit_card:'Please input your card number',
    input_cvs:'Please enter a 3 or 4 digits code found on your credit card',
    input_phone_num:'Please fill in the phone number',
    error_month:'Incorrect expiration year for credit card',
    error_year:'Incorrect expiration year for credit card',
    error_cvn:'Please enter the correct CVN number',
    confirm_infor:'Please confirm the payment information',
    no_more:'There are currently no pending orders',
    tips:'Tips',
    sure:'Confirm',
    pay_fail:'Payment failed, please check the payment information is correct',
  },
  mall_gia_search:{
    gia_diamond:'GIA Diamond',
    certificate:'Certificate',
    certificate_num:'Certificate Number',
    search_certificate_num:'Search for Number',
    hk:'HongKong',//HongKong
    foreign:'Foreign',//Foreign
    reset:'Reset',
    search:'Search',
    loading:'Loading...',
    no_more:'Sorry, we don\'t find any match diamonds for your search , please tyr again or contact our customer service!',
    carat:'Carat',
    shape:'Shape',
    color:'Color',
    clarity:'Clarity',
    cut:'Cut',
    polish:'Polish',
    symmetry:'Symmetry',
    fluorescent:'Fluorescence',
    location:'Location',
    price:'Price',
    option:'Option',
    check:'Check',
    have:'',
    items:'  Items'
  },
  mall_gia_detail:{
    diamond: 'Diamond',
    params:'Diamond Parameters',
    gia_cer:'GIA Certificate',
    contact_us:'Contact Us',
    custom_process:'Custom Process'
  }


}



// WEBPACK FOOTER //
// ./src/lang/en.js